import RequestUtils from "utils/RequestUtils";
import FindMediaLtvReq from "types/req/mediaLtv/FindMediaLtvReq";

export default class GuestAnalyticsGuestGroupApi {
  private constructor() {}
  static async find(companyId: number, data: FindMediaLtvReq) {
    return await RequestUtils.postPlain(
      `/guestAnalyticsGuestGroupLtv/find/${companyId}`,
      data
    );
  }
}
